import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventComponent } from './event/event.component';



@NgModule({
  declarations: [EventComponent],
  imports: [
    CommonModule
  ]
})
export class EventModule { }
